// production
// used for deploy version
export const API_URL = 'https://x.tradeview.com.au/api/v1';
// used for development version
// export const API_URL = 'https://tradeviewdev.online/api/v1';
export const WEBSITE_REDIRECT_URL = 'https://www.tradeview.com.au/thank_you.php';
export const PLATFORM_REDIRECT_URL = 'https://x.tradeview.com.au';

export const QUANTITY_REQUIRED_PRODUCTS = [ 4 ];

export const STRIPE_TOKEN = 'pk_live_4vICOqwR4CgM3dAp4QQXit5b0064qfLwKp';
// export const STRIPE_TOKEN = 'pk_test_9QnTZ97R6HaPEl4lsYo5KHEE00g7YFnkg1';

export const CRYPT_TO_SYMBOLS = {
  'BTC': 'BTCUSD',
  'ETH': 'XETUSD',
}

export const COUNTRIES = [
  {value: "2", label: "Albania"},
  {value: "3", label: "Algeria"},
  {value: "4", label: "Andorra"},
  {value: "7", label: "Argentina"},
  {value: "8", label: "Armenia"},
  {value: "9", label: "Australia"},
  {value: "10", label: "Austria"},
  {value: "11", label: "Azerbaijan"},
  {value: "12", label: "Bahamas"},
  {value: "13", label: "Bahrain"},
  {value: "14", label: "Bangladesh"},
  {value: "15", label: "Barbados"},
  {value: "17", label: "Belgium"},
  {value: "18", label: "Belize"},
  {value: "19", label: "Benin"},
  {value: "20", label: "Bhutan"},
  {value: "22", label: "Bosnia and Herzegovina"},
  {value: "24", label: "Brazil"},
  {value: "25", label: "Brunei"},
  {value: "26", label: "Bulgaria"},
  {value: "27", label: "Burkina Faso"},
  {value: "30", label: "Cameroon"},
  {value: "31", label: "Canada"},
  {value: "32", label: "Cape Verde"},
  {value: "34", label: "Chad"},
  {value: "35", label: "Chile"},
  {value: "36", label: "China, Peoples Republic of"},
  {value: "37", label: "Colombia"},
  {value: "38", label: "Comoros"},
  {value: "41", label: "Costa Rica"},
  {value: "43", label: "Croatia"},
  {value: "46", label: "Czech Republic"},
  {value: "47", label: "Denmark"},
  {value: "48", label: "Djibouti"},
  {value: "49", label: "Dominica"},
  {value: "50", label: "Dominican Republic"},
  {value: "51", label: "Ecuador"},
  {value: "52", label: "Egypt"},
  {value: "53", label: "El Salvador"},
  {value: "54", label: "Equatorial Guinea"},
  {value: "55", label: "Eritrea"},
  {value: "56", label: "Estonia"},
  {value: "57", label: "Ethiopia"},
  {value: "58", label: "Fiji"},
  {value: "59", label: "Finland"},
  {value: "60", label: "France"},
  {value: "61", label: "Gabon"},
  {value: "64", label: "Germany"},
  {value: "66", label: "Greece"},
  {value: "67", label: "Grenada"},
  {value: "68", label: "Guatemala"},
  {value: "69", label: "Guinea"},
  {value: "70", label: "Guinea-Bissau"},
  {value: "71", label: "Guyana"},
  {value: "72", label: "Haiti"},
  {value: "73", label: "Honduras"},
  {value: "74", label: "Hungary"},
  {value: "75", label: "Iceland"},
  {value: "76", label: "India"},
  {value: "77", label: "Indonesia"},
  {value: "80", label: "Ireland"},
  {value: "81", label: "Israel"},
  {value: "82", label: "Italy"},
  {value: "83", label: "Jamaica"},
  {value: "84", label: "Japan"},
  {value: "85", label: "Jordan"},
  {value: "86", label: "Kazakhstan"},
  {value: "87", label: "Kenya"},
  {value: "88", label: "Kiribati"},
  {value: "90", label: "Korea, South"},
  {value: "91", label: "Kuwait"},
  {value: "93", label: "Laos"},
  {value: "94", label: "Latvia"},
  {value: "99", label: "Liechtenstein"},
  {value: "100", label: "Lithuania"},
  {value: "101", label: "Luxembourg"},
  {value: "102", label: "Macedonia"},
  {value: "103", label: "Madagascar"},
  {value: "104", label: "Malawi"},
  {value: "105", label: "Malaysia"},
  {value: "106", label: "Maldives"},
  {value: "108", label: "Malta"},
  {value: "109", label: "Marshall Islands"},
  {value: "110", label: "Mauritania"},
  {value: "111", label: "Mauritius"},
  {value: "112", label: "Mexico"},
  {value: "113", label: "Micronesia"},
  {value: "114", label: "Moldova"},
  {value: "115", label: "Monaco"},
  {value: "116", label: "Mongolia"},
  {value: "117", label: "Montenegro"},
  {value: "118", label: "Morocco"},
  {value: "119", label: "Mozambique"},
  {value: "122", label: "Nauru"},
  {value: "123", label: "Nepal"},
  {value: "124", label: "Netherlands"},
  {value: "125", label: "New Zealand"},
  {value: "126", label: "Nicaragua"},
  {value: "129", label: "Norway"},
  {value: "130", label: "Oman"},
  {value: "131", label: "Pakistan"},
  {value: "132", label: "Palau"},
  {value: "133", label: "Panama"},
  {value: "134", label: "Papua New Guinea"},
  {value: "135", label: "Paraguay"},
  {value: "136", label: "Peru"},
  {value: "137", label: "Philippines"},
  {value: "138", label: "Poland"},
  {value: "139", label: "Portugal"},
  {value: "140", label: "Qatar"},
  {value: "141", label: "Romania"},
  {value: "143", label: "Rwanda"},
  {value: "144", label: "Saint Kitts and Nevis"},
  {value: "145", label: "Saint Lucia"},
  {value: "146", label: "Saint Vincent and the Grenadines"},
  {value: "147", label: "Samoa"},
  {value: "148", label: "San Marino"},
  {value: "149", label: "Sao Tome and Principe"},
  {value: "150", label: "Saudi Arabia"},
  {value: "152", label: "Serbia"},
  {value: "153", label: "Seychelles"},
  {value: "155", label: "Singapore"},
  {value: "156", label: "Slovakia"},
  {value: "157", label: "Slovenia"},
  {value: "158", label: "Solomon Islands"},
  {value: "160", label: "South Africa"},
  {value: "161", label: "Spain"},
  {value: "162", label: "Sri Lanka"},
  {value: "164", label: "Suriname"},
  {value: "165", label: "Swaziland"},
  {value: "166", label: "Sweden"},
  {value: "167", label: "Switzerland"},
  {value: "169", label: "Tajikistan"},
  {value: "171", label: "Thailand"},
  {value: "172", label: "Timor-Leste (East Timor)"},
  {value: "174", label: "Tonga"},
  {value: "175", label: "Trinidad and Tobago"},
  {value: "176", label: "Tunisia"},
  {value: "177", label: "Turkey"},
  {value: "178", label: "Turkmenistan"},
  {value: "179", label: "Tuvalu"},
  {value: "180", label: "Uganda"},
  {value: "182", label: "United Arab Emirates"},
  {value: "183", label: "United Kingdom"},
  {value: "184", label: "United States"},
  {value: "185", label: "Uruguay"},
  {value: "186", label: "Uzbekistan"},
  {value: "187", label: "Vanuatu"},
  {value: "188", label: "Vatican City"},
  {value: "190", label: "Vietnam"},
  {value: "192", label: "Zambia"},
  {value: "194", label: "Georgia"},
  {value: "195", label: "China, Republic of (Taiwan)"},
  {value: "197", label: "Northern Cyprus"},
  {value: "199", label: "Somaliland"},
  {value: "202", label: "Christmas Island"},
  {value: "203", label: "Cocos (Keeling) Islands"},
  {value: "207", label: "New Caledonia"},
  {value: "208", label: "French Polynesia"},
  {value: "209", label: "Mayotte"},
  {value: "212", label: "Saint Pierre and Miquelon"},
  {value: "213", label: "Wallis and Futuna"},
  {value: "217", label: "Cook Islands"},
  {value: "218", label: "Niue"},
  {value: "219", label: "Tokelau"},
  {value: "220", label: "Guernsey"},
  {value: "221", label: "Isle of Man"},
  {value: "222", label: "Jersey"},
  {value: "223", label: "Anguilla"},
  {value: "224", label: "Bermuda"},
  {value: "225", label: "British Indian Ocean Territory"},
  {value: "227", label: "British Virgin Islands"},
  {value: "228", label: "Cayman Islands"},
  {value: "229", label: "Falkland Islands (Islas Malvinas)"},
  {value: "230", label: "Gibraltar"},
  {value: "231", label: "Montserrat"},
  {value: "232", label: "Pitcairn Islands"},
  {value: "233", label: "Saint Helena"},
  {value: "235", label: "Turks and Caicos Islands"},
  {value: "236", label: "Northern Mariana Islands"},
  {value: "237", label: "Puerto Rico"},
  {value: "238", label: "American Samoa"},
  {value: "240", label: "Guam"},
  {value: "248", label: "U.S. Virgin Islands"},
  {value: "250", label: "Hong Kong"},
  {value: "251", label: "Macau"},
  {value: "252", label: "Faroe Islands"},
  {value: "253", label: "Greenland"},
  {value: "257", label: "Reunion"},
  {value: "259", label: "Aruba"},
  {value: "260", label: "Netherlands Antilles"},
  {value: "261", label: "Svalbard"},
  {value: "268", label: "Australian Antarctic Territory"},
  {value: "273", label: "Russian Federation"},
  {value: "277", label: "Belarus"},
  {value: "280", label: "Burundi"},
  {value: "282", label: "Central African Republic"},
  {value: "284", label: "Curacao"},
  {value: "287", label: "Ghana"},
  {value: "291", label: "Kosovo"},
  {value: "293", label: "Lebanon"},
  {value: "295", label: "Liberia"},
  {value: "301", label: "Nigeria"},
  {value: "303", label: "Palestine"},
  {value: "304", label: "Republic of the Congo"},
  {value: "305", label: "Saint Barthelemy"},
  {value: "306", label: "Saint Martin"},
  {value: "309", label: "Sint Maarten"},
  {value: "310", label: "South Sudan"},
  {value: "311", label: "Sudan"},
  {value: "315", label: "Ukraine"},
  {value: "316", label: "Venezuela"},
  {value: "317", label: "Western Sahara"},
  {value: "319", label: "Zimbabwe"},

  // SANCTIONED COUNTRIES
  // {value: "274", label: "Afghanistan"},
  // {value: "275", label: "Angola"},
  // {value: "276", label: "Antigua and Barbuda"},
  // {value: "278", label: "Bolivia"},
  // {value: "279", label: "Botswana"},
  // {value: "281", label: "Cambodia"},
  // {value: "283", label: "Cuba"},
  // {value: "285", label: "Democratic Republic of the Congo"},
  // {value: "286", label: "Gambia"},
  // {value: "288", label: "Iran"},
  // {value: "289", label: "Iraq"},
  // {value: "290", label: "Ivory Coast"},
  // {value: "292", label: "Kyrgyzstan"},
  // {value: "294", label: "Lesotho"},
  // {value: "296", label: "Libya"},
  // {value: "297", label: "Mali"},
  // {value: "298", label: "Myanmar"},
  // {value: "299", label: "Namibia"},
  // {value: "300", label: "Niger"},
  // {value: "302", label: "North Korea"},
  // {value: "307", label: "Senegal"},
  // {value: "308", label: "Sierra Leone"},
  // {value: "312", label: "Syria"},
  // {value: "313", label: "Tanzania"},
  // {value: "314", label: "Togo"},
  // {value: "318", label: "Yemen"},
];

export const TRADING_PRODUCTS = [
  { value: "stocks", label: "Stocks" },
  { value: "indices", label: "Indices" },
  { value: "forex", label: "Forex" },
  { value: "commodities", label: "Commodities" },
  { value: "others", label: "Others" },
];

export const SCROLL_OFFSET = -100;

export const SNACKBAR_INIT_VALUE = {
  open: false,
  type: "error",
  message: "",
  duration: 6000,
};

export const CartItemTypes = {
  product: 'product',
  productPackage: 'product_package',
  subscriptionPlan: 'subscription_plan',
  customOffer: 'custom_offer',
}

export const ItemPaidStatusTypes = {
  full: 2,
  half: 1,
  none: 0,
}

export const SubIntervalMap = {
  DAILY: { short: 'day', display: 'day' },
  WEEKLY: { short: 'wk', display: 'week' },
  MONTHLY: { short: 'mth', display: 'month' },
  YEARLY: { short: 'yr', display: 'year' },
}

export const ErrorCode = {
  CARD_DECLINED: 'card_declined',
  EXPIRED_CARD: 'expired_card',
  INCORRECT_CVC: 'incorrect_cvc'
}

export const DeclineCode = {
  GENERIC_DECLINE: 'generic_decline',
  INSUFFICIENT_FUNDS: 'insufficient_funds',
  INCORRECT_NUMBER: 'incorrect_number',
  TRANSACTION_NOT_ALLOWED: 'transaction_not_allowed'

}

export const SUBSCRIPTION_STATUS = {
  PAID: 'paid',
  INCOMPLETE: 'incomplete',
  ACTIVE: 'active'
}

export const PID = {
  PRODUCT: "product",
  CUSTOM_OFFER: "custom_offer",
  PRODUCT_PACKAGE: "product_package",
  SUBSCRIPTION_PLAN: "subscription_plan"
}

export const FAIR_MARKET = '62d4b0eac6d99d6123ac01ed';

export const VALID_PRICE_TIME = 86400000; // One day in ms
export const VALID_PRICE_DIFFER_PERCENT = 1 + 3 / 100;
export const NORMAL_CONVERSION_SPREAD = 0.1 * 200;
export const WEEKEND_CONVERSION_SPREAD = 0.01 * 300;

export const TVI_PHONE = '+61 3 9018 5438';

export const GUARANTEED_TIME = 60;
export const MAX_REFRESH_TIMES = 5;